/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect } from "react";
import { LinkSelectContext } from "cms/links/link-selector/context/select";
import { SelectGalleryItem } from "cms/links/link-selector/dialog-select/select/select-gallery-item";
import { isArrayNotEmpty } from "utils/empty-exists";

const LinkListGallery =() => {
    
    const {
        links,
        selectedLink,
        setMode,
        MODES
    } = useContext(LinkSelectContext);
    const hasLinks = isArrayNotEmpty(links);
    
    useEffect(() => {
        if (selectedLink) {
            setMode(MODES.SELECT_PREVIEW);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLink]);

    return (
        <>
            {hasLinks &&
                links.map((link, index) => {
                    const isSelected = link?.guid === selectedLink?.guid;
                    return (
                        <SelectGalleryItem
                            link={link}
                            isSelected={isSelected}
                            key={index}
                        />
                    );
                })
            }
        </>
    );
};
export { LinkListGallery };
